import { core } from '@tock/coretypes';

export type DeliveryServiceProviderDisplayName = 'DoorDash' | 'Uber' | 'in-house';
const deliveryServiceProviderToDisplayNameMap: {
  [K in core.DeliveryServiceProvider]: DeliveryServiceProviderDisplayName;
} = {
  INTERNAL: 'in-house',
  DOORDASH: 'DoorDash',
  POSTMATES: 'Uber',
};

/**
 * Returns the display name of a delivery service provider
 * e.g. DOORDASH -> DoorDash
 */
export function deliveryServiceProviderDisplayName(
  provider: core.DeliveryServiceProvider | null | undefined
): DeliveryServiceProviderDisplayName | null {
  return provider ? deliveryServiceProviderToDisplayNameMap[provider] : null;
}
